export default __webpack_public_path__ + "static/media/jorge-moraes.32e592a4.png";